import { render, staticRenderFns } from "./permissionAssignment.vue?vue&type=template&id=337cc228&scoped=true"
import script from "./permissionAssignment.vue?vue&type=script&lang=js"
export * from "./permissionAssignment.vue?vue&type=script&lang=js"
import style0 from "./permissionAssignment.vue?vue&type=style&index=0&id=337cc228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "337cc228",
  null
  
)

export default component.exports